import { createAsyncTypes } from 'utils/ActionCreator'

export const GET_REPORTING_REASONS_ASYNC = createAsyncTypes(
  'GET_ASYNC',
  'Settings/CustomizationO365/GET_REPORTING_REASONS_ASYNC'
)
export const UPDATE_REPORTING_REASONS_ASYNC = createAsyncTypes(
  'UPDATE_ASYNC',
  'Settings/CustomizationO365/UPDATE_REPORTING_REASONS_ASYNC'
)
export const RESTORE_DEFAULT_REASONS_ASYNC = createAsyncTypes(
  'RESTORE_ASYNC',
  'Settings/CustomizationO365/RESTORE_DEFAULT_REASONS_ASYNC'
)
